var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRainbow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 266.547,
    cy: 278.095,
    gradientUnits: "userSpaceOnUse",
    r: 351.294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#e80c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1317,
    stopColor: "#f12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#f73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3708,
    stopColor: "#fc406d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5503,
    stopColor: "#fe4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4974"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 406.569,
    cy: 422.454,
    gradientUnits: "userSpaceOnUse",
    r: 300.834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff90a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#ff94a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4131,
    stopColor: "#ffa093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6301,
    stopColor: "#ffb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8491,
    stopColor: "#ffce61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe548"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 491.343,
    cy: 488.455,
    gradientUnits: "userSpaceOnUse",
    r: 350.605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b8eac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4f8b6"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 471.278,
    cy: 475.61,
    gradientUnits: "userSpaceOnUse",
    r: 220.04
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fa9f5"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.651,
    x2: 134.2,
    xlinkHref: "#lg1",
    y1: 197.779,
    y2: 81.319
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.344,
    x2: 89.901,
    xlinkHref: "#lg2",
    y1: 405.934,
    y2: 268.29
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.246,
    x2: 67.211,
    xlinkHref: "#lg1",
    y1: 303.426,
    y2: 183.391
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.729,
    x2: 347.729,
    xlinkHref: "#lg2",
    y1: 191.16,
    y2: 81.16
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.432,
    x2: 361.151,
    y1: 252.455,
    y2: 162.364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b8eac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.453,
    x2: 173.715,
    xlinkHref: "#lg3",
    y1: 38.966,
    y2: 141.092
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.659,
    x2: 113.29,
    xlinkHref: "#lg3",
    y1: 181.63,
    y2: 232.694
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.836,
    x2: 427.467,
    xlinkHref: "#lg3",
    y1: 173.873,
    y2: 224.936
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.083,
    x2: 160.714,
    xlinkHref: "#lg3",
    y1: 289.174,
    y2: 340.237
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.081,
    x2: 422.712,
    xlinkHref: "#lg3",
    y1: 99.24,
    y2: 150.303
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.075 510h271.414c7.546 0 13.777-5.863 14.268-13.393 6.771-103.932 91.748-187.066 195.829-193.692 7.54-.48 13.415-6.715 13.415-14.27v-273.57c0-8.466-6.981-15.32-15.444-15.068-269.514 8.012-486.538 225.036-494.55 494.549-.252 8.463 6.601 15.444 15.068 15.444z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m77.865 510h208.623c7.546 0 13.777-5.863 14.268-13.393 6.771-103.934 91.746-187.066 195.829-193.692 7.54-.48 13.415-6.715 13.415-14.27v-210.78c-238.66 0-432.135 193.475-432.135 432.135z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m149.216 510h137.272c7.546 0 13.777-5.863 14.268-13.393 6.771-103.934 91.746-187.066 195.829-193.692 7.54-.48 13.415-6.715 13.415-14.27v-139.429c-199.259 0-360.784 161.525-360.784 360.784z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m227.499 510h58.99c7.546 0 13.777-5.863 14.268-13.393 6.771-103.934 91.746-187.066 195.829-193.692 7.54-.48 13.415-6.715 13.415-14.27v-61.146c-156.025-.001-282.502 126.477-282.502 282.501z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m420.46 322.54c-25.72 12.15-48.65 29.35-67.4 50.3l-211.23-211.22c-.62-.97-1.24-1.92-1.89-2.87-.99-1.5-2.02-2.97-3.08-4.43.29-.56.61-1.11.91-1.66.18-.31.35-.63.53-.95.33-.56.68-1.12 1.02-1.68.26-.41.52-.81.78-1.22.34-.51.67-1.02 1.03-1.52.37-.54.77-1.07 1.16-1.6s.79-1.05 1.2-1.57c.55-.69 1.1-1.37 1.68-2.04.28-.32.57-.64.86-.96.54-.6 1.1-1.19 1.66-1.77.27-.28.54-.55.81-.82.84-.84 1.7-1.66 2.6-2.46l41.91-37.13c.32-.29.62-.6.93-.9 2.15 1.56 4.34 3.08 6.56 4.54z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m307.92 454.76c-1.29 4.57-2.42 9.21-3.38 13.91-4.32-.72-8.7-1.48-13.14-2.28-2.17.4-4.35.81-6.54 1.19-6.52 1.15-13.1 2.18-19.7 3.13l-143.84-143.89c-2.09-1.37-2.09-4.48 0-5.84 9.39-6.15 17.4-14.23 23.45-23.68 1.37-2.13 4.52-2.13 5.88 0z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m325.33 412.08c-7.17 13.12-12.95 27.09-17.14 41.71l-210.84-210.83c-3.14-4.9-6.81-9.42-10.91-13.5.2-.81.42-1.61.66-2.4.03-.09.06-.18.09-.27.22-.71.45-1.41.7-2.11.03-.09.07-.19.1-.29.38-1.03.79-2.05 1.23-3.04.55-1.27 1.15-2.5 1.79-3.7.04-.06.07-.12.11-.19.34-.64.71-1.27 1.08-1.9.06-.09.11-.18.16-.27.4-.65.81-1.29 1.23-1.92.02-.02.03-.05.05-.07.91-1.35 1.88-2.65 2.91-3.9.03-.05.07-.09.11-.14.46-.55.93-1.1 1.41-1.64.08-.08.16-.17.24-.26.48-.52.96-1.03 1.46-1.53l.17-.17c.58-.58 1.16-1.14 1.77-1.69.57-.52 1.15-1.02 1.74-1.52.06-.05.12-.09.18-.14.53-.44 1.07-.86 1.61-1.27.13-.1.27-.2.4-.3.5-.37 1-.73 1.5-1.08.14-.09.28-.19.42-.28.59-.4 1.18-.79 1.78-1.16.04-.02.08-.05.12-.07 1.71 2.03 3.54 3.98 5.44 5.83l.24-.15c.58.69 1.18 1.38 1.79 2.05 3.05 2.76 6.3 5.3 9.75 7.56z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m510 205.093-97.35-97.729c-1.362-2.125-4.515-2.125-5.878 0-6.058 9.452-14.065 17.537-23.456 23.682-2.084 1.364-2.084 4.474 0 5.837l126.684 126.49z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m417.405 181.997c-1.362-2.125-4.515-2.125-5.878 0-6.058 9.452-14.065 17.537-23.456 23.682-2.084 1.364-2.084 4.474 0 5.837l93.104 92.961c5.085-.703 10.223-1.232 15.411-1.563 7.539-.48 13.415-6.715 13.415-14.27v-13.693z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m200.503 114.252c-18.782 12.289-34.797 28.459-46.914 47.364-2.725 4.251-9.031 4.251-11.755 0-12.116-18.905-28.13-35.075-46.913-47.363-4.169-2.728-4.169-8.947 0-11.675 18.782-12.289 34.797-28.459 46.913-47.363 2.724-4.251 9.03-4.251 11.755 0 12.116 18.905 28.132 35.075 46.914 47.364 4.169 2.726 4.169 8.945 0 11.673z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m126.684 219.273c-9.391 6.144-17.399 14.229-23.457 23.682-1.362 2.126-4.515 2.126-5.878 0-6.058-9.452-14.065-17.537-23.456-23.682-2.085-1.364-2.084-4.474 0-5.837 9.391-6.144 17.399-14.229 23.456-23.682 1.362-2.126 4.515-2.126 5.878 0 6.058 9.452 14.066 17.537 23.457 23.682 2.085 1.364 2.085 4.474 0 5.837z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m440.862 211.516c-9.391 6.144-17.399 14.229-23.457 23.682-1.362 2.126-4.515 2.126-5.878 0-6.058-9.452-14.065-17.537-23.456-23.682-2.085-1.364-2.084-4.474 0-5.837 9.391-6.144 17.399-14.229 23.456-23.682 1.362-2.126 4.515-2.126 5.878 0 6.058 9.452 14.066 17.537 23.457 23.682 2.084 1.363 2.084 4.473 0 5.837z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m174.108 326.817c-9.391 6.144-17.399 14.229-23.457 23.682-1.362 2.126-4.515 2.126-5.878 0-6.058-9.452-14.065-17.537-23.456-23.682-2.085-1.364-2.085-4.474 0-5.837 9.391-6.144 17.399-14.229 23.456-23.682 1.362-2.126 4.515-2.126 5.878 0 6.058 9.452 14.066 17.537 23.457 23.682 2.084 1.363 2.084 4.473 0 5.837z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m436.106 136.883c-9.391 6.144-17.399 14.229-23.457 23.682-1.362 2.126-4.515 2.126-5.878 0-6.058-9.452-14.065-17.537-23.456-23.682-2.085-1.364-2.084-4.474 0-5.837 9.391-6.144 17.399-14.229 23.456-23.682 1.362-2.126 4.515-2.126 5.878 0 6.058 9.452 14.066 17.537 23.457 23.682 2.085 1.363 2.085 4.473 0 5.837z",
    fill: "url(#SVGID_14_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRainbow);
export default __webpack_public_path__ + "static/media/icon-rainbow.655bdb632e4fbef2923fdc64625beb07.svg";
export { ForwardRef as ReactComponent };